import * as React from 'react';
import { IGenericUser } from '@bb/users';
import { findDeleted } from 'api/UserController';
import { Color } from '@bb/elements-web-rebranding';
import { Button } from 'components';
import { featureEnabled } from 'utils';
import PanelHeader from '../../../../app/react-common/PanelHeader';
import PanelBody from '../../../../app/react-common/PanelBody';
import Loading from '../../../../app/react-common/Loading';

interface ManageDeletedStaffListState {
  userDataLoaded: boolean;
  // TODO: Add user interface
  users: IGenericUser[];
}

interface ManageDeletedStaffListProps {
  active?: number;
  deleted?: number;
}

class ManageDeletedStaffList extends React.Component<
  ManageDeletedStaffListProps,
  ManageDeletedStaffListState
> {
  constructor(props: ManageDeletedStaffListProps) {
    super(props);

    this.state = {
      userDataLoaded: false,
      users: [],
    };
  }

  fetchUserData = () => {
    this.setState({ userDataLoaded: false }, async () => {
      // We have to use a callback here because TypeScript does not play nice
      // with promisify overloads

      const users = await findDeleted();

      this.setState({
        users,
        userDataLoaded: true,
      });
    });
  };

  componentDidMount() {
    this.fetchUserData();
  }

  public render() {
    const { userDataLoaded, users } = this.state;
    const { active, deleted } = this.props;

    return (
      <>
        <PanelHeader title="Deleted Staff" />

        <nav className="content animate-panel tabs">
          <ul className="nav nav-tabs">
            <li key="active">
              <a href="/#/answering/manage-staff">
                Active
                {typeof active === 'number' && ` - ${active}`}
              </a>
            </li>
            <li key="deleted" className="active">
              <a href="/#/answering/manage-deleted-staff">
                Deleted
                {typeof deleted === 'number' && ` - ${deleted}`}
              </a>
            </li>
          </ul>
        </nav>

        <PanelBody>
          <div className="manage-users-list-body">
            {/* Users list */}
            {userDataLoaded && users.length !== 0 && (
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {users.map(user => (
                    <tr key={user.id}>
                      <td>{user.firstName}</td>
                      <td>{user.lastName}</td>
                      <td>{user.email}</td>
                      <td>{user.role}</td>
                      <td>
                        {featureEnabled('supraRebrandingFeature', 1) ? (
                          <Button
                            type="primary"
                            href={`/#/users/edit/${user.id}?showHistory=true&from=manage-deleted-staff`}
                            style={{ color: Color.WHITE, fontWeight: 600 }}
                          >
                            View History
                          </Button>
                        ) : (
                          <a
                            href={`/#/users/edit/${user.id}?showHistory=true&from=manage-deleted-staff`}
                            className="btn btn-info"
                          >
                            View History
                          </a>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* No Users found */}
            {userDataLoaded && users.length === 0 && (
              <div className="panel-body">
                <label>No deleted users found.</label>
              </div>
            )}

            {/* Loading */}
            {!userDataLoaded && <Loading size="fa-5x" />}
          </div>
        </PanelBody>
      </>
    );
  }
}

export default ManageDeletedStaffList;
